import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BicBadgeComponent} from '@buildinginformationcloud/bic-ui-components';
import {ProposalChangeStatus} from '../../../ruleManagement/proposal/mycheck-diff';

const BADGE: Record<ProposalChangeStatus, {type: 'info' | 'success' | 'error'; text: string}> = {
  changed: {type: 'info', text: 'Geändert'},
  added: {type: 'success', text: 'Neu'},
  removed: {type: 'error', text: 'Wird gelöscht'},
};

/**
 * Badge für die Art einer Änderung aus einem chatBIC-Vorschlag (#2789): „Geändert“ (grau), „Neu“
 * (grün), „Wird gelöscht“ (rot). Genutzt von `app-change-marker` (Kopfzeile) und `app-removed-rule-card`.
 */
@Component({
  selector: 'app-proposal-status-badge',
  standalone: true,
  imports: [BicBadgeComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<bic-badge [type]="badge.type">{{ badge.text }}</bic-badge>`,
})
export class ProposalStatusBadgeComponent {
  @Input({required: true}) status!: ProposalChangeStatus;

  protected get badge(): {type: 'info' | 'success' | 'error'; text: string} {
    return BADGE[this.status] ?? BADGE.changed;
  }
}
